/**
 * @author: lv.chen
 * @date: 2025/12/15
 * @desc: ProductChangedRank异动榜
 */
import React, { useState } from 'react';
import classnames from 'classnames';
import ProductChangedRankCommonMetric from './ProductChangedRankCommonMetric';
import ProductChangedRankStore from './ProductChangedRankStore';
import ProductChangedRankMiniGame from './ProductChangedRankMiniGame';
import { isEmpty } from '@intelligence/v3/utils/common';

import IMG_WX from '@intelligence/assets/imgs/casualDailyReports/icon-weixin.png';
import IMG_DOUNYIN from '@intelligence/assets/imgs/casualDailyReports/icon-dy.png';

interface IProductChangedRankProps extends IBaseProps {
  sensortowerDownloadChangeRank?: ISensorTowerCommonMetricChangeRankItem[] | null;
  sensortowerDauChangeRank?: ISensorTowerCommonMetricChangeRankItem[] | null;
  sensortowerRevenueChangeRank?: ISensorTowerCommonMetricChangeRankItem[] | null;
  storeRankChangeRank?: IStoreRankChangeItem[] | null;
  /** 微信人气榜数据 */
  popularityRanksWeixin?: IMiniGameRankItem[] | null;
  /** 微信畅玩榜数据 */
  mostPlayedRanksWeixin?: IMiniGameRankItem[] | null;
  /** 抖音人气榜数据 */
  popularityRanksDouyin?: IMiniGameRankItem[] | null;
  /** 抖音新游榜单数据 */
  freshGameRanksDouyin?: IMiniGameRankItem[] | null;
  onGoToGameDetails?: (game?: any, tab?: string) => void;
}

const ProductChangedRank: React.FC<IProductChangedRankProps> = (props) => {
  const {
    style,
    className,
    sensortowerDownloadChangeRank,
    sensortowerDauChangeRank,
    sensortowerRevenueChangeRank,
    storeRankChangeRank,
    popularityRanksWeixin,
    mostPlayedRanksWeixin,
    popularityRanksDouyin,
    freshGameRanksDouyin,
    onGoToGameDetails,
  } = props;

  // 小游戏异动榜展开/收起状态，默认收起（显示Top3）
  const [isMiniGameExpanded, setIsMiniGameExpanded] = useState(false);

  const handleToggleExpand = () => {
    setIsMiniGameExpanded((prev) => !prev);
  };

  return (
    <div style={style} className={classnames('dbi-casual-daily-reports-changed-rank', className)}>
      <div className="dbi-common-tips">
        <div className="dbi-common-tips-item">
          商店榜单及小游戏榜单为当日实时数据；活跃、收入、下载指标来源于SensorTower，T-2延迟
        </div>
        <div className="dbi-common-tips-item">
          监控各指标前500的休闲游戏，统计7日变化率&gt;50%且变化量&gt;10万，按变化量排序
        </div>
      </div>

      <div className="dbi-update-rank-card-list">
        {(!isEmpty(sensortowerDownloadChangeRank) || !isEmpty(sensortowerDauChangeRank)) && (
          <>
            <ProductChangedRankCommonMetric
              rankTitle="下载异动榜"
              rankSubTitle="近7日累计下载"
              ranks={sensortowerDownloadChangeRank}
              onGoToGameDetails={onGoToGameDetails}
            />
            <ProductChangedRankCommonMetric
              rankTitle="DAU异动榜"
              rankSubTitle="近7日日均DAU"
              noDataText="官方数据调整中，暂无数据"
              ranks={sensortowerDauChangeRank}
              onGoToGameDetails={onGoToGameDetails}
            />
          </>
        )}
        {(!isEmpty(sensortowerRevenueChangeRank) || !isEmpty(storeRankChangeRank)) && (
          <>
            <ProductChangedRankCommonMetric
              className="dbi-casual-daily-reports-changed-rank--revenue"
              rankTitle="收入异动榜"
              rankSubTitle="近7日累计收入"
              ranks={sensortowerRevenueChangeRank}
              onGoToGameDetails={onGoToGameDetails}
              footer={<div className="dbi-update-rank-tips">收入已扣除30%渠道分成</div>}
            />
            <ProductChangedRankStore
              ranks={storeRankChangeRank}
              onGoToGameDetails={(game) => {
                onGoToGameDetails?.(game, 'storeRank');
              }}
            />
          </>
        )}
        <ProductChangedRankMiniGame
          title="微信小游戏异动榜-国区"
          platformIcon={IMG_WX}
          firstRankTitle="人气榜"
          firstRankClass="--popularity"
          secondRankTitle="畅玩榜"
          secondRankClass="--enjoy"
          popularityRanks={popularityRanksWeixin}
          secondaryRanks={mostPlayedRanksWeixin}
          isExpanded={isMiniGameExpanded}
          onToggleExpand={handleToggleExpand}
        />
        <ProductChangedRankMiniGame
          title="抖音小游戏异动榜-国区"
          platformIcon={IMG_DOUNYIN}
          firstRankTitle="热门榜"
          firstRankClass="--remen"
          secondRankTitle="新游榜"
          secondRankClass="--xinyou"
          popularityRanks={popularityRanksDouyin}
          secondaryRanks={freshGameRanksDouyin}
          isExpanded={isMiniGameExpanded}
          onToggleExpand={handleToggleExpand}
        />
      </div>
    </div>
  );
};

export default ProductChangedRank;
